import $ from "jquery";
import { useState } from "react";
import ReactQuill from 'react-quill';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import './brd.css';

function Write_brd(){

  let navigate = useNavigate();
  let [types, setTypes] = useState();
  let [contents, setContents] = useState("");
  let id = window.localStorage.getItem('id');
  let login_key = window.localStorage.getItem('login_key');
  const config = {
    headers : {
      'Authorization': `Bearer ${login_key}`
    }
  }

  const modules = {
    toolbar: {
        container: [
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          [{ 'font': [] }],
          [{ 'align': [] }],
          ['bold', 'italic', 'underline', 'strike', 'blockquote'],
          [{ 'list': 'ordered' }, { 'list': 'bullet' }, 'link'],
          [{ 'color': ['#000000', '#e60000', '#ff9900', '#ffff00', '#008a00', '#0066cc', '#9933ff', '#ffffff', '#facccc', '#ffebcc', '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff', '#bbbbbb', '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0', '#c285ff', '#888888', '#a10000', '#b26b00', '#b2b200', '#006100', '#0047b2', '#6b24b2', '#444444', '#5c0000', '#663d00', '#666600', '#003700', '#002966', '#3d1466', 'custom-color'] }, { 'background': [] }],
          ['image']
        ],
    }
  }

  return(
    <div className="page-container container">
      <div className="sections write property_section">
        <div className="">
          <Link to="/board" className="back-link">
            ← 목록으로
          </Link>

          <h3>게시글 등록</h3>

          <form id="writeBoard">
            <div className="panel">
              <div className="section_box">
                <div className="">
                  <select name="code" className="select_type" onChange={(e)=>{
                    setTypes(e.target.value);
                  }}>
                    <option value='notice'>공지</option>
                    <option value='event'>이벤트</option>
                    <option value='charge'>이용요금</option>
                    <option value='review'>이용후기</option>
                    <option value='vod'>홍보영상</option>
                  </select>
                </div>

                <div className="">
                  <div className="input_title_con">
                    <input type="text" name="board_title" className="write_title" placeholder="글제목"></input>
                  </div>
                  {
                    types === 'review' ? <Score_con></Score_con> : null
                  }
                </div>
                <div className="">
                  <ReactQuill modules={modules} onChange={(e)=>{setContents(e);}} value={contents}></ReactQuill>
                </div>

                {
                  types === 'vod' ? <Row4></Row4> : null
                }
              </div>

              <div className="section_box">
                <div className="btn_con">
                  <div></div>
                  <div className="right">
                    <div className="btn btn-primary" onClick={()=>{
                    const this_form = document.getElementById("writeBoard");
                    let formData = new FormData(this_form);
                    if(contents){
                      formData.append('board_content', contents);
                    }
                    formData.append('board_writer', id);
                    if(window.confirm('저장하시겠습니까?')){
                      if($(".write_title").val() === ''){
                        alert('제목을 입력해주세요.')
                      }else{
                        axios.post(process.env.REACT_APP_API_KEY+'Admin/Board/save', formData, config).catch(()=>{
                          alert("데이터 전송이 실패하였습니다.");
                        }).then((result)=>{
                          console.log(result);
                          alert('저장되었습니다');
                          navigate(-1);
                        });
                      }
                    }
                    for (const [key, value] of formData.entries()) {
                      console.log(key, value);
                    }
                  }}>
                      <span>저장하기</span>
                    </div>

                    <div className="btn btn-muted">
                      <span><Link to='/board'>취소</Link></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

function Score_con(){
  const checkOnlyOne = (checkThis) => {
    const checkboxes = document.getElementsByName('score');
    for (let i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i] !== checkThis) {
        checkboxes[i].checked = false
      }
    }
  }
  return(
    <div className="score_con">
      <h5>리뷰 평점</h5>
      <div className="check_score">
        <input type="checkbox" name="score" value={5} onChange={(e) => checkOnlyOne(e.target)}></input>
        <img src="img/board/write/star.png"></img>
        <img src="img/board/write/star.png"></img>
        <img src="img/board/write/star.png"></img>
        <img src="img/board/write/star.png"></img>
        <img src="img/board/write/star.png"></img>
        <span>아주 좋아요</span>
      </div>
      <div className="check_score">
        <input type="checkbox" name="score" value={4} onChange={(e) => checkOnlyOne(e.target)}></input>
        <img src="img/board/write/star.png"></img>
        <img src="img/board/write/star.png"></img>
        <img src="img/board/write/star.png"></img>
        <img src="img/board/write/star.png"></img>
        <span>맘에 들어요</span>
      </div>
      <div className="check_score">
        <input type="checkbox" name="score" value={3} onChange={(e) => checkOnlyOne(e.target)}></input>
        <img src="img/board/write/star.png"></img>
        <img src="img/board/write/star.png"></img>
        <img src="img/board/write/star.png"></img>
        <span>보통이예요</span>
      </div>
      <div className="check_score">
        <input type="checkbox" name="score" value={2} onChange={(e) => checkOnlyOne(e.target)}></input>
        <img src="img/board/write/star.png"></img>
        <img src="img/board/write/star.png"></img>
        <span>그냥 그래요</span>
      </div>
      <div className="check_score">
        <input type="checkbox" name="score" value={1} onChange={(e) => checkOnlyOne(e.target)}></input>
        <img src="img/board/write/star.png"></img>
        <span>별로예요</span>
      </div>
    </div>
  )
}

function Row4(){
  return(
    <div className="row">
      <p className="opt">영상 첨부 방식 두가지 중 한가지를 선택해주세요</p>
      <div className="upload_vod">
        <h5>영상첨부</h5>
        <div style={{display:"flex", alignItems:"center", gap: "10px",}}>
          <input type="file" name="file" className="input_vod" accept="video/*"></input>
          <span onClick={()=>{$(".input_vod").val('')}}><FontAwesomeIcon icon={faXmark}></FontAwesomeIcon></span>
        </div>
      </div>
      <div className="upload_vod">
        <h5>영상URL</h5>
        <input type="text" name="movie_url" className="input_url" placeholder="유튜브 영상 URL을 입력해주시면 영상을 불러올 수 있습니다."></input>
      </div>
    </div>
  )
}

export default Write_brd;